module.exports = __webpack_public_path__ + "img/ZNLS.adb1d01c.png";